import { internalApi } from '../api';

export default {
  async loadData({ commit, dispatch }, payload) {
    commit('setLoading', true);

    const configs = await internalApi.get(`/users/${user.id}/project/${payload}/config/board`).then(response => {
      const configs = response.data
        .filter(item => item.userId === user.id)
        .reduce((acc, item) => {
          acc[item.projectId] = typeof item.config === 'string' ? JSON.parse(item.config) : item.config;

          return acc;
        }, {});

      return configs;
    });

    commit('setProjectId', payload);
    commit('setBoardConfigs', configs);
    await dispatch('setAllFields', payload);
    await dispatch('loadCustomSort', payload);

    commit('setLoading', false);
  },

  async loadCustomSort({
    commit,
  }, payload) {
    const customSort = await internalApi.get(`/sortingindexation/${user.id}/board`).then(response => {
      let data = response.data;

      if (response.status !== 200) {
        data = [];
      }

      return data;
    });

    commit('setCustomSort', customSort);
  },

  async setAllFields({
    commit, dispatch, getters, rootGetters,
  }, payload) {
    return internalApi.get(`projects/taskFields?projectId=${payload}`).then(response => {
      const fields = [...response.data];

      commit('setAllFields', fields);

      return fields;
    });
  },

  setGroupOrder({ commit, state, getters }, { config }) {
    const customGroupingOptions = getters.customGroupingOptions;
    const grouping = config.grouping;
    const currentConfig = getters.currentConfig;

    if (customGroupingOptions && customGroupingOptions.length > 0) {
      let isItemUpdated = false;
      const updatedOrderData = customGroupingOptions.map(item => {
        if (item.fieldId === grouping[0].fieldId) {
          item.order = grouping[0].order;
          isItemUpdated = true;
        }

        return item;
      });

      currentConfig.customGroupingOptions = isItemUpdated ? updatedOrderData : [...updatedOrderData, grouping[0]];
    } else {
      currentConfig.customGroupingOptions = [grouping[0]];
    }

    commit('setBoardConfig', {
      ...currentConfig,
    });
  },

  clearCustomSort({
    commit, state, getters, dispatch,
  }) {
    internalApi.delete(`/sortingindexation/${user.id}/board`).then(() => {
      commit('setCustomSort', []);
    });
  },

  setBoardConfig({
    commit, state, getters, dispatch,
  }, { config }) {
    const initialConfig = { ...getters.currentConfig };

    commit('setBoardConfig', {
      ...getters.currentConfig,
      ...config,
    });

    // update local grouping
    dispatch('setGroupOrder', {
      config: {
        grouping: config.grouping,
      },
    });

    // we have been always update data on the backend
    internalApi.put(`/users/${user.id}/project/${state.projectId}/settings/board`, config).then(response => {
      if (response.status !== 200) {
        commit('setBoardConfig', initialConfig);
      }
    });
  },

  setCustomSort({
    commit, getters,
  }, payload) {
    const storeCustomSort = [...getters.customSort];
    const fullIndexing = payload.fullIndexing;
    const addedIndex = payload.addedIndex;
    // const data = [];
    // let removeIndex; // нужно для в случаи, если задача переносится в другую колонку
    // Проверяем, существует ли колонка в сторе. Если нет, создаем ее
    const isExistColumn = storeCustomSort.find(column => +column.groupKey === payload.columnId);

    if (!isExistColumn) {
      storeCustomSort.push({
        groupKey: payload.columnId,
        tasks: [],
      });
    }

    storeCustomSort.map(column => {
      if (+column.groupKey === payload.columnId) {
        // если есть таски в колонке
        column.tasks = payload.tasks.map(item => ({
          userId: user.id,
          position: item.position,
          taskId: item.id,
          groupKey: payload.columnId,
        }));
      }
    });

    // подготовка данных для отправки на бэк
    const dataForRequest = {
      tasks: [],
    };

    if (payload.tasks.length > 0 && fullIndexing) {
      payload.tasks.forEach(task => {
        dataForRequest.tasks.push({
          position: task.position,
          taskId: task.id,
          groupKey: payload.columnId !== 'empty' ? payload.columnId : -1,
        });
      });
    } else if (
      payload.tasks.length > 0 && !fullIndexing && addedIndex !== undefined && addedIndex !== null
    ) {
      dataForRequest.tasks.push({
        position: payload.tasks[addedIndex].position,
        taskId: payload.tasks[addedIndex].id,
        groupKey: payload.columnId !== 'empty' ? payload.columnId : -1,
      });
    }

    if (dataForRequest.tasks.length) {
      internalApi.post(`/sortingindexation/${user.id}/board`, dataForRequest);
    }

    commit('setCustomSort', storeCustomSort);
  },

  setDefaultGroupingConfig({ getters, dispatch }) {
    const statusField = getters.getField(false, 'status');
    const newGroupingConfig = [{
      fieldId: statusField.id,
      isCustomField: false,
      order: statusField.options.map(({ id }, index) => ({ id, order: (index + 1) })),
    }];

    dispatch('setBoardConfig', {
      config: {
        grouping: newGroupingConfig,
        customGroupingOptions: [],
      },
    });
  },
  setContextMenu({ commit }, payload) {
    commit('setContextMenu', payload);
  },
  setNameEditKey({ commit }, payload) {
    commit('setNameEditKey', payload);
  },
  clearNameEditTaskKey({ commit }) {
    commit('setNameEditKey', 0);
  },
  setTaskCardEditing({ commit }, payload) {
    commit('setTaskCardEditing', payload);
  },
  setTaskSettingsInfo({ commit }, payload) {
    commit('setTaskSettingsInfo', payload);
  },
  addNewTaskToPool({ commit }, payload) {
    commit('addNewTaskToPool', payload);
  },
  removeNewTaskFromPool({ commit }, payload) {
    commit('removeNewTaskFromPool', payload);
  },
  clearNewTasksPool({ commit }) {
    commit('clearNewTasksPool');
  },
  resetState({ commit }) {
    commit('resetState');
  },
  setDatesWidth({ commit }, payload) {
    commit('setDatesWidth', payload);
  },
  clearContextMenus({ commit }) {
    commit('clearContextMenus');
  }
};
